import { Link } from "react-router-dom";
import { categories } from "@/mocks/navCategories";

export default function CategorySidebar({ activeId }: { activeId: string }) {
  const active = categories.find((item) => item.id === activeId);

  return (
    <aside className="w-full lg:w-[256px] shrink-0 space-y-4">
      <div className="rounded-lg bg-background-50 border border-background-200 p-3">
        <h2 className="px-2 py-1.5 text-xs font-medium text-foreground-400">全部分类</h2>
        <div className="space-y-0.5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className={`flex items-center gap-2 px-2.5 py-2 rounded-md text-sm transition-colors cursor-pointer ${
                cat.id === activeId
                  ? "bg-primary-50 text-primary-700 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i
                  className={`${cat.icon} text-base ${
                    cat.id === activeId ? "text-primary-500" : "text-foreground-400"
                  }`}
                />
              </span>
              <span className="truncate">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>

      {active && (
        <div className="rounded-lg bg-background-50 border border-background-200 p-4">
          <h2 className="text-sm font-medium text-foreground-950 mb-2">本分类子领域</h2>
          <div className="flex flex-wrap gap-1.5">
            {active.children.map((child) => (
              <span
                key={child.id}
                className="px-2 py-1 rounded bg-secondary-100 text-secondary-800 text-xs"
              >
                {child.name}
              </span>
            ))}
          </div>
          <p className="mt-3 text-xs text-foreground-500 leading-5">{active.description}</p>
        </div>
      )}

      <div className="hidden lg:block rounded-lg bg-primary-900 p-4 text-background-50">
        <h2 className="text-sm font-medium">没找到合适的网站？</h2>
        <p className="mt-1.5 text-xs text-background-100/80 leading-5">
          告诉我们你常用的网站，编辑会在审核后补充进分类。
        </p>
        <Link
          to="/about#feedback"
          className="mt-3 inline-flex items-center gap-1 px-3 py-1.5 rounded-md bg-accent-500 text-background-50 text-xs hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          提交网址
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="hidden lg:block rounded-lg bg-background-50 border border-background-200 p-4">
        <h2 className="text-sm font-medium text-foreground-950 mb-2">关于收藏演示</h2>
        <p className="text-xs text-foreground-500 leading-5">
          收藏使用浏览器本地存储保存，仅用于功能演示，暂无账号体系与云端同步。
        </p>
        <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
          <i className="ri-lock-2-line" />
          数据仅保存在本设备浏览器
        </div>
      </div>
    </aside>
  );
}